import React from "react";
import "../style/ContactUs.css";
import { Mail, Phone, MapPin } from "lucide-react";

function ContactUs() {
  const handleEmailClick = (event) => {
    const gmailWebUrl =
      "https://mail.google.com/mail/?view=cm&fs=1&to=conference@iitm.tech";
    const isAndroid = /Android/i.test(navigator.userAgent || "");

    if (!isAndroid) {
      event.preventDefault();
      window.open(gmailWebUrl, "_blank");
    }
    // On Android, let the default mailto: behavior handle it
  };
  return (
    <div className="contact-container">
      <div className="contact-content">
        <h1>Contact Details</h1>

        <div className="contact-card">
          <div className="contact-header">
            <h2>CO-CONVENOR</h2>
              <h3>Prof. (Dr.) Priyanka Murria</h3>
          </div>

          <div className="contact-info">
            <p className="designation">IITM College of Enginnering</p>

            <div className="contact-details">
              <div className="contact-item">
                <Phone className="icon" />
                <div>
                  <strong>Contact Number:</strong>
                  <p>+91 96547 80250</p>
                </div>
              </div>

              <div className="contact-item">
                <Mail className="icon" />
                <div>
                  <strong>E-mail:</strong>
                  <div className="email-links">
                    <a
                      href="mailto:conference@iitm.tech"
                      onClick={handleEmailClick}
                      title="You will need to sign in to your Google account to contact us."
                    >
                      conference@iitm.tech
                    </a>
                  </div>
                </div>
              </div>

              <div className="contact-item">
                <MapPin className="icon" />
                <div>
                  <strong>Address:</strong>
                  <p>
                    IITM College of Engineering
                    <br />
                    Approved by AICTE & Affiliated to Maharshi Dayanand University, Rohtak
                    <br />
                    Bahadurgarh–Jhajjar Road, Village Lowa Khurd, Near D. P. S,
                    <br />
                    Bahadurgarh (Delhi NCR) 124507 (Haryana), India
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="contact-card">
          <div className="contact-header">
            <h2>CO-CONVENOR</h2>
              <h3>Prof. (Dr.) Subhra Kulshrestha</h3>
          </div>

          <div className="contact-info">
            <p className="designation">IITM College of Enginnering</p>

            <div className="contact-details">
              <div className="contact-item">
                <Phone className="icon" />
                <div>
                  <strong>Contact Number:</strong>
                  <p>+91 96547 95970</p>
                </div>
              </div>

              <div className="contact-item">
                <Mail className="icon" />
                <div>
                  <strong>E-mail:</strong>
                  <div className="email-links">
                    <a
                      href="mailto:conference@iitm.tech"
                      onClick={handleEmailClick}
                      title="You will need to sign in to your Google account to contact us."
                    >
                      conference@iitm.tech
                    </a>
                  </div>
                </div>
              </div>

              <div className="contact-item">
                <MapPin className="icon" />
                <div>
                  <strong>Address:</strong>
                  <p>
                    IITM College of Engineering
                    <br />
                    Approved by AICTE & Affiliated to Maharshi Dayanand University, Rohtak
                    <br />
                    Bahadurgarh–Jhajjar Road, Village Lowa Khurd, Near D. P. S,
                    <br />
                    Bahadurgarh (Delhi NCR) 124507 (Haryana), India
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="contact-card">
          <div className="contact-header">
            <h2>STUDENT COORDINATOR</h2>
            <h3>Mr. Priyansh Bharti</h3>
          </div>

          <div className="contact-info">
            <p className="designation">IITM College of Enginnering</p>

            <div className="contact-details">
              <div className="contact-item">
                <Phone className="icon" />
                <div>
                  <strong>Contact Number:</strong>
                  <p>+91 98731 91217</p>
                </div>
              </div>

              <div className="contact-item">
                <Mail className="icon" />
                <div>
                  <strong>E-mail:</strong>
                  <div className="email-links">
                    <a
                      href="mailto:conference@iitm.tech"
                      onClick={handleEmailClick}
                      title="You will need to sign in to your Google account to contact us."
                    >
                      conference@iitm.tech
                    </a>
                  </div>
                </div>
              </div>

              <div className="contact-item">
                <MapPin className="icon" />
                <div>
                  <strong>Address:</strong>
                  <p>
                    IITM College of Engineering
                    <br />
                    Approved by AICTE & Affiliated to Maharshi Dayanand University, Rohtak
                    <br />
                    Bahadurgarh–Jhajjar Road, Village Lowa Khurd, Near D. P. S,
                    <br />
                    Bahadurgarh (Delhi NCR) 124507 (Haryana), India
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="contact-card">
          <div className="contact-header">
            <h2>STUDENT COORDINATOR</h2>
            <h3>Ms. Jiya Chaddha</h3>
          </div>

          <div className="contact-info">
            <p className="designation">IITM College of Enginnering</p>

            <div className="contact-details">
              <div className="contact-item">
                <Phone className="icon" />
                <div>
                  <strong>Contact Number:</strong>
                  <p>+91 93159 76855</p>
                </div>
              </div>

              <div className="contact-item">
                <Mail className="icon" />
                <div>
                  <strong>E-mail:</strong>
                  <div className="email-links">
                    <a
                      href="mailto:conference@iitm.tech"
                      onClick={handleEmailClick}
                      title="You will need to sign in to your Google account to contact us."
                    >
                      conference@iitm.tech
                    </a>
                  </div>
                </div>
              </div>

              <div className="contact-item">
                <MapPin className="icon" />
                <div>
                  <strong>Address:</strong>
                  <p>
                    IITM College of Engineering
                    <br />
                    Approved by AICTE & Affiliated to Maharshi Dayanand University, Rohtak
                    <br />
                    Bahadurgarh–Jhajjar Road, Village Lowa Khurd, Near D. P. S,
                    <br />
                    Bahadurgarh (Delhi NCR) 124507 (Haryana), India
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="map-container">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d56015.37919141561!2d76.81746772163818!3d28.66088042047319!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d0d004f7be92d%3A0x41901378f1beccf5!2sIITM%20College%20of%20Engineering!5e0!3m2!1sen!2sin!4v1764255099874!5m2!1sen!2sin"
            width="600"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="IITM Location Map"
          ></iframe>
        </div>
      </div>
    </div>
  );
}

export default ContactUs;
